import { UrlSubdirectoryTypes } from "features/searchResultsFacets";

export default class PageType {
  /**
   * The static get Homes function returns an instance of the 'Home_Results' class.
   * @returns The method is returning an instance of the 'Home_Results' class.
   */
  static get Homes() {
    return this.getInstance('Home_Results');
  }

  /**
   * The function returns an instance of the 'Community_Results' class.
   * @returns The method `get Communities()` is returning the result of calling the `getInstance`
   * method with the argument `'Community_Results'`.
   */
  static get Communities() {
    return this.getInstance('Community_Results');
  }

  /**
   * The function returns an instance of the 'Builder_Results' class.
   * @returns The method `get Builders()` is returning the result of calling the `getInstance`
   * method with the argument `'Builder_Results'`.
   */
  static get Builders() {
    return this.getInstance('Builder_Results');
  }

  /**
   * The function returns an instance of the 'boylresults' class.
   * @returns The method `get BuildOnYorLotLocations()` is returning the result of calling the `getInstance`
   * method with the argument `'boylresults'`.
   */
  static get BuildOnYorLotLocations() {
    return this.getInstance('boylresults');
  }
      
  /**
   * The function returns an instance of the 'Custom_Homes' class.
   * @returns The method `get CustomHomes()` is returning the result of calling the `getInstance`
   * method with the argument `'Custom_Homes'`.
   */
  static get CustomHomes() {
    return this.getInstance('Custom_Homes');
  }
      
  /**
   * The function returns an instance of the 'Manufactured_Homes' class.
   * @returns The method `get ManufacturedHomes()` is returning the result of calling the `getInstance`
   * method with the argument `'Manufactured_Homes'`.
   */
  static get ManufacturedHomes() {
    return this.getInstance('Manufactured_Homes');
  }
      
  /**
   * The function returns an instance of the 'Manufactured_Results' class.
   * @returns The method `get Manufactured()` is returning the result of calling the `getInstance`
   * method with the argument `'Manufactured_Results'`.
   */
  static get Manufactured() {
    return this.getInstance('Manufactured_Results');
  }

 /**
  * The static method `LearningCenter` returns an instance of the 'Learning Center'.
  * @returns An instance of the "Learning Center" object is being returned.
  */
 /**
  * The static method `LearningCenter` returns an instance of the 'Learning Center'.
  * @returns An instance of the "Learning Center" class.
  */
  static get LearningCenter() {
    return this.getInstance('Learning Center');
  }

/**
 * The function `NewAndTrends` returns an instance of a specific class named 'NewAndTrends'.
 * @returns An instance of the 'NewAndTrends' class is being returned.
 */
  static get NewsAndTrends() {
    return this.getInstance('NewsAndTrends');
  }
  
  /**
   * The function "fromKey" takes a key as input and returns the corresponding value from a
   * predefined map.
   * @param key - The `key` parameter is a string that represents a key in the `statusMap` object.
     * It should be formatted like {product type}-{result type}.
   * @returns The value associated with the given key in the statusMap object is being returned.
   */
  static fromKey(key) {
    const statusMap = {
      [UrlSubdirectoryTypes.Communities.toString()]: PageType.Communities,
      [UrlSubdirectoryTypes.Homes.toString()]: PageType.Homes,
      [UrlSubdirectoryTypes.Builders.toString()]: PageType.Builders,
      [UrlSubdirectoryTypes.CondoDevelopment.toString()]: PageType.Communities,
      [UrlSubdirectoryTypes.CondosAndTownHomes.toString()]: PageType.Homes,
      [UrlSubdirectoryTypes.SingleFamilyHomes.toString()]: PageType.Homes,
      [UrlSubdirectoryTypes.SingleFamilyCommunities.toString()]: PageType.Communities,
      [UrlSubdirectoryTypes.CustomHomes.toString()]: PageType.CustomHomes,
      [UrlSubdirectoryTypes.OnYourLot.toString()]: PageType.BuildOnYorLotLocations,
      [UrlSubdirectoryTypes.ManufacturedHomes.toString()]: PageType.ManufacturedHomes,
      [UrlSubdirectoryTypes.ManufacturedLocations.toString()]: PageType.Manufactured,
      [UrlSubdirectoryTypes.FloorPlans.toString()]: PageType.Homes,
      [UrlSubdirectoryTypes.ModelHomes.toString()]: PageType.Homes,
      [UrlSubdirectoryTypes.LearningCenter.toString()]: PageType.LearningCenter,
      [UrlSubdirectoryTypes.NewsAndTrends.toString()]: PageType.NewsAndTrends,
    };
    return statusMap[key];
  }

  /**
   * Gets an instance of a PageType object based on a given name.
   * If the instance does not already exist, it creates a new instance using the configuration provided.
   *
   * @param name a unique identifier used to retrieve or create an instance of the PageType class.
   * @param configuration an object that contains various properties and values that are used to configure
   * the instance of the PageType class that is being created.
   *
   * @returns an instance of `PageType` that corresponds to the given `name`.
   */
  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new PageType(key);
    }
    return this.instances[key];
  }

  /**
   * This is a constructor function that takes a name as a parameter and sets the name
   * @param name -The `name` property is a string that represents the name of the
   * configuration
   */
  constructor(name) {
    this.name = name;
  }

  /**
   * Method that returns the name property of an object as a string.
   * @returns returns the `name` property of that object as a string.
   */
  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(PageType, 'instances', { value: {} });
